
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/caucus/mint",
      function () {
        return require("private-next-pages/caucus/mint.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/caucus/mint"])
      });
    }
  